export const getExternalUrls = () => {
    const isWebViewFromStorage = sessionStorage.getItem("isWebView") === "true";
    const isRedirectToWelcomeScreenFromStorage = sessionStorage.getItem("fromWelcomeScreen") === "true";

    // defaultLinks - linky používané v aplikaci, když není spuštěna ve webView - přístup z BROWSERU
    const defaultLinks = {
        LOGIN_PAGE_URL: process.env.REACT_APP_LOGIN_PAGE_URL,
        GDPR_PAGE_URL: process.env.REACT_APP_GDPR_PAGE_URL,
        BACK_TO_SOURCE: isRedirectToWelcomeScreenFromStorage ? process.env.REACT_APP_BACK_TO_SOURCE_WELCOME_SCREEN : process.env.REACT_APP_BACK_TO_SOURCE_REG_IDENTIFICATION
    };

    // webViewLinks - linky používané v aplikaci, když je spuštěna v webView - přístup z MOBILNÍ APLIKACI
    const webViewLinks = {
        LOGIN_PAGE_URL: process.env.REACT_APP_LOGIN_PAGE_URL_IS_WEB_VIEW,
        GDPR_PAGE_URL: undefined,
        BACK_TO_SOURCE: isRedirectToWelcomeScreenFromStorage ? process.env.REACT_APP_BACK_TO_SOURCE_WELCOME_SCREEN_IS_WEB_VIEW : process.env.REACT_APP_BACK_TO_SOURCE_REG_IDENTIFICATION_IS_WEB_VIEW
    };
    return isWebViewFromStorage ? webViewLinks : defaultLinks;
};
